import gql from "graphql-tag";

export const SLUMPS_QUERY = gql`
  query {
    slumps {
      id
      nominal
      deviation
      abntValue
      specification
      description
    }
  }
`;

export const SLUMP_QUERY = gql`
  query($id: Int!) {
    slump(id: $id) {
      id
      nominal
      deviation
      abntValue
      specification
      description
    }
  }
`;

export const CEMENT_TYPES_QUERY = gql`
  query {
    cementTypes {
      id
      name
    }
  }
`;

export const CEMENT_TYPE_QUERY = gql`
  query($id: Int!) {
    cementType(id: $id) {
      id
      name
    }
  }
`;

export const SUPPLIERS_QUERY = gql`
  query {
    suppliers {
      id
      name
      phone
      email
    }
  }
`;

export const LOCATION_QUERY = gql`
  query($id: Int!) {
    inventoryLocation(id: $id) {
      id
      name
      code
      capacity
      sensor {
        id
        name
        materialType
      }
      monitorSensor {
        id
        name
        materialType
      }
    }
  }
`;

export const LOCATIONS_QUERY = gql`
query {
  inventoryLocations {
    id
    name
    code
    capacity
    sensor {
      id
      name
      materialType
    }
    monitorSensor {
      id
      name
      materialType
    }
  }
}
`;

export const SUPPLIER_QUERY = gql`
  query($id: Int!) {
    supplier(id: $id) {
      id
      name
      phone
      email
    }
  }
`;

export const INVENTORY_ITEMS_QUERY = gql`
  query {
    inventoryItems {
      id
      name
      code
      materialType
      unit
      avgPrice
      comments
    }
  }
`;

export const INVENTORY_ITEM_QUERY = gql`
  query($id: Int!) {
    inventoryItem(id: $id) {
      id
      name
      code
      ncm
      materialType
      partNumber
      qrCode
      unit
      comments
    }
  }
`;

export const MATERIAL_TYPES_QUERY = gql`
  query {
    __type(name: "MaterialTypeEnum") {
      states: enumValues {
        name
      }
    }
  }
`;

export const SENSORS_QUERY = gql`
  query {
    sensors {
      id
      name
      unit
      materialType
    }
  }
`;

export const SENSOR_QUERY = gql`
  query($id: Int!) {
    sensor(id: $id) {
      id
      name
      unit
      materialType
    }
  }
`;

export const ACTUATORS_QUERY = gql`
  query {
    actuators {
      id
      name
      type
      maintenanceMode
      status
      plantLocation {
        id
        name
      }
    }
  }
`;

export const ACTUATOR_QUERY = gql`
  query($id: Int!) {
    actuator(id: $id) {
      id
      name
      type
      maintenanceMode
      status
      plantLocation {
        id
        name
      }
    }
  }
`;

export const PLANT_LOCATIONS_QUERY = gql`
  query {
    plantLocations {
      id
      name
      locationType
      arrowPosition
      positionX
      positionY
      isContainerVertical
      numberOfColumns
      inventoryItems {
        id
        name
      }
    }
  }
`;

export const PLANT_LOCATION_QUERY = gql`
  query($id: Int!) {
    plantLocation(id: $id) {
      id
      name
      locationType
      arrowPosition
      positionX
      positionY
      isContainerVertical
      numberOfColumns
      inventoryItems {
        id
        name
      }
    }
  }
`;

export const LOCATION_TYPES_QUERY = gql`
  query {
    locationTypes: __type(name: "LocationTypeEnum") {
      states: enumValues {
        name
      }
    }
  }
`;

export const ARROW_POSITIONS_QUERY = gql`
  query {
    arrowPositions: __type(name: "ArrowPositionEnum") {
      states: enumValues {
        name
      }
    }
  }
`;

export const SENSOR_MATERIAL_TYPES_QUERY = gql`
  query {
    __type(name: "SensorMaterialTypeEnum") {
      states: enumValues {
        name
      }
    }
  }
`;

export const DEVICES_QUERY = gql`
  query {
    devices {
      id
    }
  }
`;
